import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/Auth/LoginForm';

const LoginPage = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = () => {
    navigate('/similarity-search');
  };

  return <LoginForm onSuccess={handleLoginSuccess} />;
};

export default LoginPage;